$(document).ready(function () {
  // ADD SIZE AND COLOR TO TOP OF ROW
  $("#collection .collection-row").each(function () {
    var size = $(this).find(".sizetotal").html();
    var color = $(this).find(".colortotal").html();
    if(size == undefined){
    } else {
      if(size==1){
        size="";
      }else{
        size= size + " sizes / ";
      }
      $(this).find(".sizecount").html(size);
    }
    if(color==1){
      color="1 color available";
    }else{
      color = color + " colors available";
    }
    $(this).find(".colorcount").html(color);
  });

  $("#collection .collection-nav-heading").click(function(){
      $(".collection-nav-content").each(function () {
          $( this).slideToggle( "fast", function() {});
  	  });
      if($(this).hasClass("collection-nav-open")){
        $(this).removeClass("collection-nav-open");
      } else {
        $(this).addClass("collection-nav-open");
      }
  });
  $( window ).resize(function() {
    if($(window).width() > 960){
      $(".collection-nav-content").each(function () {
          $( this).show();
  	  });
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");   
  var scrollTop = window.pageYOffset;
  lazyloadImages.forEach(function(img) {
    if(img.offsetTop < (window.innerHeight + scrollTop)) {
      img.src = img.dataset.src;
      img.classList.remove('lazy');
    }
  });
});


$(document).ready(function () {
  
  // PRODUCT TILES FADE IN PRODUCT INFO

  $('.collection-content').on('mouseenter', '.item', function() {
      $(this).find(".title").show();    
  });
  $('.collection-content').on('mouseleave', '.item', function() {
      $(this).find(".title").hide();    
  });
  


  $('.collection-content').on('mouseenter', '.item .image, .item .btn-quickadd-container', function() {
      $(this).find("img").each((idx, image) => {
        const galleryImageUrl = $(image).attr(`data-gallery-image-${idx}`)
        if(!galleryImageUrl) $(image).attr("src", $(image).attr("variant-src"));
      })
  });
  $('.collection-content').on('mouseleave', '.item .image, .item .btn-quickadd-container', function() {
      $(this).find("img").each((idx, image) => {
        const galleryImageUrl = $(image).attr(`data-gallery-image-${idx}`)
        if(!galleryImageUrl) $(image).attr("src", $(image).attr("product-src"));
      })
  });

  $('.collection-content').on('mouseenter', '.item .btn-quickadd-container', function() {
      let img = $(this).siblings('.image').first().find("img");
      img.attr("src", img.attr("variant-src")) ;
  });
  $('.collection-content').on('mouseleave', '.item .btn-quickadd-container', function() {
      let img = $(this).siblings('.image').first().find("img");
      img.attr("src", img.attr("product-src")) ;
  });
  
  $('.search-results, .collection-categories, .collection-grid').on('mouseenter', '.item', function() {
    if($(window).width() > 640){
      showIcons();
    }    
  });
  $('.search-results, .collection-categories, .collection-grid').on('mouseleave', '.item', function() {
    if($(window).width() > 640){

      hideIcons();
    }
  });
  function showIcons() {
      $(this).find(".product-loop-icon-organic").show(); 
      $(this).find(".smartwishlist.active").show();  
      $(this).find(".wk-button-collection").show();  
  }
  function hideIcons() {
      $(this).find(".product-loop-icon-organic").hide();
      $(this).find(".smartwishlist.active").hide();  
      $(this).find(".wk-button-collection").hide();  
  }


  
});

/***********************************/
/* NEW COLLECTION GRID STARTS HERE */
/***********************************/


function handleSwatchChange() {
  $(".new-grid .swatch :radio").change(function() {
    const swatch = $(this).parent()
    var id = swatch.attr("data-id");
    var product = swatch.attr("data-product");
    var color = swatch.attr("data-color");
    var material = swatch.attr("data-material");
    var image = swatch.attr("data-product-src");
    var hover = swatch.attr("data-variant-src");
    var url = swatch.attr("data-url");
    var atc = swatch.attr("data-atc");
    var stock = swatch.attr("data-stock");
    var waitlist = swatch.attr("data-waitlist");
    var compareatprice = parseInt(swatch.attr("data-compareatprice").replace(/[^0-9\.-]+/g,""));
    var displaycompareatprice = swatch.attr("data-compareatprice");
    var badge = swatch.attr("data-badge");
    const name = swatch.attr("data-product-name")
    var price = parseInt($(this).parent().attr("data-price").replace(/[^0-9\.-]+/g,""));
    var displayprice = $(this).parent().attr("data-price");
    //const currencySymbol = $("#selected-currency-symbol").val();

    $("."+id).each(function() {
      const selectedSwatch = $(this).find(`.swatch-element[data-color='${color}'][data-material='${material}']`)
      const selectedSwatchInput = $(selectedSwatch).find('input')
      const selectedSwatchBadge = $(selectedSwatch).attr('data-badge')
      selectedSwatchInput[0].checked = true;

      $(this).find(".image").attr("href",url);
      const sliderImages = $(this).find(".image .swiper-slide")
      
      const productLinks = $(this).find("[data-product-links]")
      if(productLinks.length) {
        $(productLinks).each((idx, link) => {
          $(link).attr("href", url);
        })
      }
      const notQuickAdd = $(this).find(".not_quick_add");
      const quickAdd = $(this).find(".product_loop_atc")
      const updateAvailableState = (state, el) => {
        if(state == "soldout"){
          $(el).removeClass("available");
          $(el).addClass("soldout");
          url = url + '-WAITLIST';
          if($(el).hasClass('product_loop_atc')) $(el).attr("href",url);
          
          if(waitlist == 'y'){
            $(el).addClass('btn-quickadd--outline');
            $(el).removeClass('btn-quickadd--disabled');
            $(this).find(`${el.selector} .soldout-text`).text('Waitlist');
          } else {
            $(el).addClass('btn-quickadd--disabled');
            $(el).removeClass('btn-quickadd--outline');
            $(this).find(`${el.selector} .soldout-text`).text('All gone');
          }
        } else if(state == "preorder") {
          $(el).addClass("available");
          $(el).removeClass("soldout btn-quickadd--outline btn-quickadd--disabled");
          if($(el).hasClass('product_loop_atc')) $(el).attr("href",atc);
          $(this).find(`${el.selector} .available-text`).text('Pre-order');
        } else {
          $(el).addClass("available");
          $(el).removeClass("soldout btn-quickadd--outline btn-quickadd--disabled");
          if($(el).hasClass('product_loop_atc')) $(el).attr("href",atc);
          $(this).find(`${el.selector} .available-text`).text('Add to Bag');
        }
      }

      updateAvailableState(stock, notQuickAdd.length ? notQuickAdd : quickAdd)

      $(this).find(".product_loop_color_title").html(color);
      //$(this).find(".final-price").html("from $"+price);
      $(this).find(".final-price").html(displayprice);

      if(compareatprice > price){
        $(this).find(".product_loop_compare-specific-price").html(displaycompareatprice).show();
        $(this).find(".final-price").addClass("discounted");
        $(this).find(".final-price").attr('data-discounted', true)
      } else {
        $(this).find(".product_loop_compare-specific-price").html("").hide();
        $(this).find(".final-price").removeClass("discounted");
        $(this).find(".final-price").attr('data-discounted', false)
      }
      if(material == 'mesh'){
        $(this).find(".product-loop-sticker").removeClass("hide");
      } else {
        $(this).find(".product-loop-sticker").addClass("hide");
      }

      if(sliderImages.length) {
        $(sliderImages).each((idx, slide) => {
          const imageUrl = selectedSwatch.attr(`data-image-${idx}`)
          if(imageUrl) $(slide).attr('src', imageUrl)
        })
      } else {
        const img = $(this).find(".image img");

        $(img).attr("variant-src", hover);
        $(img).attr("product-src", image);
        $(img).attr("src", image);
      }
      
      const eventDetails = $(this).find('.js-dynamic-event-detail')
      if(eventDetails.length) {
        $(eventDetails).each((idx, detail) => {
          $(detail).attr('data-event-detail', name);
        })
      }

      const iconContainer = $(this).find(".product-loop-badge [data-badge-icon]")
      const badgeContainer = $(this).find(".product-loop-badge")
      
      if(selectedSwatchBadge){
        const badge = selectedSwatchBadge
        const isDiscountBadge = badge.toUpperCase().includes('SALE') || badge.includes('%') || badge.toUpperCase().includes('LAST CALL')

        $(badgeContainer).attr('data-badge-type', `${ isDiscountBadge && stock !== "soldout" ? 'discount' : 'marketing'}`);
        if(iconContainer) $(iconContainer).attr('data-badge-icon', `${ isDiscountBadge && stock !== "soldout" ? '' : `${stock === "soldout" ? 'Out of Stock' : badge}`}`);

        $(this).find(".nonhover").addClass("hide");
        $(badgeContainer).removeClass("hide");
        $(this).find(".product-loop-badge-text").text(`${stock === "soldout" ? 'Out of Stock' : badge}`);
      } else {
        $(this).find(".nonhover").removeClass("hide");

        if(stock === "soldout" && iconContainer){
          $(badgeContainer).attr('data-badge-type', 'marketing');
          $(iconContainer).attr('data-badge-icon', 'Out of Stock');
          $(this).find(".product-loop-badge-text").text('Out of Stock');
        } else {
          $(this).find(".product-loop-badge").addClass("hide");
        }
      }
    }); 
    
    $("."+id+" .swym-button").each(function() {
      if($(this).attr("data-product-id") == product){
        $(this).addClass("active");
        $(this).show();
      } else {
        $(this).removeClass("active");
        $(this).hide();
      }
    }); 
    
  }); 
}
    $(function(){
      handleSwatchChange();
	  });  
    $('.poptip-trigger').on('click', function () {
      $(this).next().show();  
    });
    $('.poptip-close').on('click', function () {
      $(this).parent().parent().hide();
    });
    $(document).keyup(function(e) {
      if (e.keyCode === 27) $('.poptip-close').click();   // esc
    });
	$( document ).ready(function() {
      $(".collection-content").on( "click", ".product_loop_atc.product_loop_atc_old", function(e) {
        if($(this).hasClass("available")){
          e.preventDefault();    
          var variantid = $(this).attr("href");
          variantid = variantid.split("?id=");
          variantid = variantid[variantid.length - 1];
          variantid = variantid.replace('&quantity=1','');
          var plus = $(this).html();

          var shippingtext = $(this).attr("data-preorder");

          if(shippingtext == ""){
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: variantid                
                },
              async: false
            });
          } else {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: variantid,
                properties: { "Note": shippingtext }
                },
              async: false
            });
          }
          
          setTimeout(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                addToCartBtn: e.target
              }
            }));          
          }, 200);
        }
      });
	}); 

    // MOBILE/DESKTOP VIDEO RESIZE 
    $( document ).ready(function() {
        function checkVisible( elm, eval ) {
            eval = eval || "visible";
            var vpH = $(window).height(), // Viewport Height
                st = $(window).scrollTop(), // Scroll Top
                y = $(elm).offset().top,
                elementHeight = $(elm).height();
            if (eval == "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
            if (eval == "above") return ((y < (vpH + st)));
        } 
        window.addEventListener('scroll', function(){
          $('.collection-products .video').each( function(){ 
            if($(this).hasClass("played")){
            } else {
              if (checkVisible($(this))) {
                this.play();
              }
            }
          }); 
        });  
    });
    var globalsize = 0;
    function resizeVideo() { 
      if ($(window).width() > 640) { 
        if (globalsize != 1 ){
          $('.video').each( function(){ 
            if($(this).hasClass("video-mobile")){
              $(this).hide();
              if($(this).paused){
              } else {
                $(this).trigger('pause');
              }
            } else {
              $(this).show();
              if($(this).paused){
                $(this).trigger('load');	
                $(this).trigger('play');	
              }
            }
          });
          globalsize = 1;
        }	
      } else {
        if (globalsize != 2 ){
          $('.video').each( function(){ 
            if($(this).hasClass("video-desktop")){
              $(this).hide();
              if($(this).paused){
              } else {
                $(this).trigger('pause');
              }
            } else {
              $(this).show();
              if($(this).paused){
                $(this).trigger('load');	
                $(this).trigger('play');	
              }
            }
          });
          globalsize = 2;
        }	
      } 
    }
    $(window).resize(function() {
        resizeVideo();
    }); 
    $( document ).ready(function() {        
        resizeVideo();
    });

function reloadWishlistState(wishlistButtons) {
  if(wishlistButtons.length) {
    wishlistButtons.forEach((button) => {
      const variantId = button.getAttribute("data-variant-id");
      const swymProducts = JSON.parse(localStorage.getItem("swym-products")) || { all: [] };
      const isCurrentlySelected = swymProducts.all.find(
        (product) => product?.epi === Number(variantId)
      );
      
      if(isCurrentlySelected) button.classList.add("swym-added");

      button.classList.add("swym-loaded");
    });
  }
}
  
function swymCallbackFn(wishlistButtons){
  if(wishlistButtons.length){
    wishlistButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if(SwymPageData){
          SwymPageData.et = 4;
          SwymPageData.epi = Number(button.getAttribute("data-variant-id"));
          SwymPageData.empi = Number(button.getAttribute("data-product-id"));
          _swat.addToWishList(SwymPageData, function(product){
            if(product?.cts){
              const swymProducts = JSON.parse(localStorage.getItem("swym-products")) || { all: [] };
              const productExists = swymProducts.all.find(
                ({epi}) => epi === product?.epi
              );
              if (!productExists) {
                swymProducts.all.push(product);
              } else {
                swymProducts.all = swymProducts.all.filter(
                  ({epi}) => epi !== product?.epi
                );
              }
              button.classList.toggle("swym-added");
              localStorage.setItem("swym-products", JSON.stringify(swymProducts));
            }
          });
        }
      }); 
    })
  }
}

document.addEventListener('filteredGrid:added', () => {
  $(".wishlist_show_signin").click(function(e){
    e.preventDefault();
    $('#force_signup_background').show();
    $('#force_signup_content').show();
    $('#customer-login').find('.page-title').html('Sign In to add to your wishlist');
  });
  handleSwatchChange()
  const wishlistButtons = document.querySelectorAll(".swym-button")
  reloadWishlistState(wishlistButtons);

  if(!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(() => swymCallbackFn(wishlistButtons));
 
  if (window.swymJSShopifyLoad) window.swymJSShopifyLoad();
})
